import "core-js/modules/es6.regexp.replace";
export default {
  name: 'VftAvatar',
  data: function data() {
    return {
      loadError: false
    };
  },
  props: {
    src: {
      type: String,
      required: true
    },
    iclass: {
      type: String,
      default: ''
    },
    defaultAvatar: {
      type: String,
      default: '//vm.gtimg.cn/tencentvideo/vstyle/newvip/style/h5/imgs/common/head_default.svg'
    }
  },
  computed: {
    avatarUrl: function avatarUrl() {
      if (!this.src || this.loadError) return this.defaultAvatar;

      if (/^http(s?):/.test(this.src)) {
        return this.src.replace(/^http(s?):/, '');
      } else if (/^\/\//.test(this.src)) {
        return this.src;
      } else if (/^data:/.test(this.src)) {
        return this.src;
      } else {
        return this.defaultAvatar;
      }
    }
  },
  methods: {
    click: function click(event) {
      this.$emit('click', event);
    },
    onError: function onError() {
      this.loadError = true;
    }
  }
};